import { getUserProfile } from 'helpers/userProfile';
import { ReactElement, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useFilterContext } from '../../contexts/FilterContext';
import { canViewThermalComfort } from '../../helpers/thermalComfort';
import { FilterOptions, ViewOption } from '../../types';
import { Option, Select } from '../SelectField';
import { healthComfortOptions, statusComfortOptions, statusHealthOptions } from './constants';
import { FilterFieldsContainer } from './styles';
import { XIcon } from '~/icons';
import { ContainerClearFilters } from '../SelectField/styles';

interface FilterFieldsProps {
  filterOptions: FilterOptions;
}

export function FilterFields({
  filterOptions,
}: Readonly<FilterFieldsProps >): ReactElement | null {
  const [profile] = useState(getUserProfile);
  const {
    client,
    onSelectClient,
    onSelectOption,
    onSelectView,
    clearFilter,
    selectedOptions,
    viewOption,
  } = useFilterContext();
  const { t } = useTranslation();

  const hasClientInput = !!(profile.manageAllClients || profile.manageMultipleClients);

  function onSelectGroup(value: string): void {
    const units = filterOptions.groups.find((item) => item.value === value)?.units ?? [];

    onSelectOption('group', value, units);
  }

  function getViewOptions(): Option[] {
    if (canViewThermalComfort(profile)) {
      return healthComfortOptions;
    }

    return healthComfortOptions.map(
      (item) => (item.value === 'thermalComfort' ? { ...item, label: t('confortoTermicoEmBreve'), comingSoon: true } : item),
    );
  }

  function clearFilters(): void {
    clearFilter('state');
    clearFilter('group');
    clearFilter('healthStatus');
    clearFilter('status');
  }
  const hasSelectedOptionsClear = (selectedOptions.group || selectedOptions.state || selectedOptions.status || selectedOptions.healthStatus);
  return (
    <FilterFieldsContainer hasClientInput={hasClientInput}>
      {hasClientInput && (
        <Select
          options={filterOptions.clients}
          placeholder={t('selecionarCliente')}
          value={client}
          icon="User1Icon"
          onSelect={onSelectClient}
          isSearchable
        />
      )}
      {client && (
        <>
          <Select
            icon={viewOption === 'health' ? 'ActivityIcon' : 'Thermometer2Icon'}
            options={getViewOptions()}
            placeholder=""
            value={viewOption}
            onSelect={(value) => onSelectView(value as ViewOption)}
          />
          <Select
            icon="BookmarkIcon"
            options={
              viewOption === 'health'
                ? statusHealthOptions
                : statusComfortOptions
            }
            placeholder={t('selecionarStatus')}
            value={viewOption === 'health' ? selectedOptions.healthStatus : selectedOptions.status}
            onSelect={(value) => onSelectOption(viewOption === 'health' ? 'healthStatus' : 'status', value)}
          />
          <Select
            icon="MarkerPin1Icon"
            options={filterOptions.states}
            placeholder={t('selecionarEstado')}
            value={selectedOptions.state}
            onSelect={(value) => onSelectOption('state', value)}
            multiple
            isSearchable
          />
          {!profile.manageAllClients && filterOptions.groups.length > 0 && (
            <Select
              icon="LayoutGrid1Icon"
              options={filterOptions.groups}
              placeholder={t('selecionarGrupo')}
              value={selectedOptions.group?.value}
              onSelect={onSelectGroup}
            />
          )}
        </>
      )}
      {
        hasSelectedOptionsClear && (
          <ContainerClearFilters onClick={clearFilters}>
            <XIcon />
          </ContainerClearFilters>
        )
      }
    </FilterFieldsContainer>
  );
}
